import React, { useCallback, useEffect, useState } from 'react'
import { connect } from 'react-redux';
import UserDucks from 'stores/ducks/User.duck';
import Label from "reactstrap/lib/Label";
import { Info } from 'components/common/form/modules/Info';
import { NumberInput } from 'components/common/form/modules/input/Number';
import { TextArea } from 'components/common/form/modules/input/TextArea';
import { API_ENDPOINTS, fetchAPI } from 'components/graphql/FetchApi'
import { getInventoryItemsAsString, shareInventoryItems } from 'components/graphql/queries'
import { closeModal } from 'components/modal/modules/dispatcher/methods';
import PropTypes from 'prop-types';
import { ClipLoader } from 'react-spinners';
import Tooltip from '@material-ui/core/Tooltip';
import MultiSelect from "@khanacademy/react-multi-select";
import { Text } from 'components/common/form/modules/input/Text';

const ValueLabelComponent = (props) => {
    const { children, open, value } = props;
    return (
        <Tooltip open={open} enterTouchDelay={0} placement="right" title={value}>
            {children}
        </Tooltip>
    );
}

ValueLabelComponent.propTypes = {
    children: PropTypes.element.isRequired,
    open: PropTypes.bool.isRequired,
    value: PropTypes.number.isRequired,
};

const PassOnInventoryModal: React.FC<{ [label: string]: any }> = (props: any) => {

    if (props.user.id === '') {
        return null;
    }

    const [campaignId] = useState(props.campaignId)
    const [username, setUsername] = useState(props.email ? props.email : '')
    const [inventory, setInventory] = useState([{ quantity: 0, commission: 0, price: 0 }])
    const [modifiedInventory, setModifiedInventory] = useState([]);
    const op = props.currentAffiliates
    const tempOptions: any[] = []
    if (op) {
        op.map((item: any) => {
            if (item.username && !item.username.includes("-additional-link-")) {
                tempOptions.push({
                    label: item.username.toLowerCase().trim(),
                    value: item.email.toLowerCase().trim()
                })
            }
        })
    }
    const [options] = useState<any[]>(tempOptions)
    const [selected, setSelected] = useState<any[]>([])
    const [loading, setLoading] = useState(true)
    const [btnDisabled, setBtnDisabled] = useState(false)
    const [shareBtnText, setShareBtnText] = useState('SHARE')
    const [createBtnText, setCreateBtnText] = useState('CREATE')
    const [linkName, setLinkName] = useState('')

    useEffect(() => {
        fetchAPI
            .post(API_ENDPOINTS.BASE_URL, {
                query: getInventoryItemsAsString,
                variables: {
                    campaignId,
                    sellerId: props.user.isAdmin ? props.createdBy : props.user.id
                }
            })
            .then(res => {
                setLoading(false)
                const int = JSON.parse(res.data.data.inventoryItem.getInventoryAsString)
                const parsedFormatInventory = int.map((item: any) => {
                    return {
                        name: item.name,
                        commission: Number(item.commission) / 100,
                        commissionRate: null,
                        bought: Number(item.bought),
                        quantity: Number(item.quantity),
                        price: Number(item.price) / 100,
                        inventoryItemId: item.id,
                        quantityForShare: Number(item.quantity) - Number(item.bought)
                    }
                })
                const modifiableParsedFormatInventory = int.map((item: any) => {
                    // Dividing by two to get the slider in the right position
                    return {
                        name: item.name,
                        commission: 0,
                        commissionRate: null,
                        quantity: Number(item.quantity),
                        bought: Number(item.bought),
                        price: Number(item.price) / 100,
                        inventoryItemId: item.id,
                        quantityForShare: Number(item.quantity) - Number(item.bought)
                    }
                })
                setInventory(parsedFormatInventory)
                setModifiedInventory(modifiableParsedFormatInventory)
            })
            .catch(err => {
                console.log(err)
            })

    }, [setLoading, campaignId, props.user, setInventory, setModifiedInventory, props.user, props.createdBy])

    const resetBtn = () => {
        if (props.email) {
            setCreateBtnText('CREATE')
        } else {
            setShareBtnText('SHARE')
        }
    }

    const handlePassOn = useCallback(() => {

        let error = false

        if (username === '' && selected.length === 0) {
            error = true
            return alert('Usernames/Emails required')
        }

        if (props.email && props.email.includes('-additional-link-') && props.forNewLink !== undefined && props.forNewLink) {
            if (linkName === '') {
                error = true
                return alert('Link Name required')
            }

            if (linkName.includes('-')) {
                error = true
                return alert('Link Name must not contain -')
            }
        }

        modifiedInventory.forEach((item: any) => {

            const orgItem = inventory.find((i: any) => {
                return item.inventoryItemId === i.inventoryItemId
            })

            if (Number(item.quantity) < 0 || Number(item.quantity) > Number(orgItem!.quantity)) {
                error = true
                alert('Quantity is invalid for one or more items')
            }

            if (Number(item.commission) < 0 || Number(item.commission) > Number(orgItem!.commission)) {
                error = true
                alert('Commision is invalid for one or more items')
            }

        })

        if (!error) {
            const trimmedData: string[] = JSON.parse(JSON.stringify(selected));
            username.toLowerCase().split("\n").map(item => {
                if (props.user.username.toString().trim() !== item.toString().trim() && props.user.email.toString().trim() !== item.toString().trim()) {
                    trimmedData.push(item.trim())
                }
            });

            setBtnDisabled(true)
            if (props.email) {
                setCreateBtnText('CREATING...')
            } else {
                setShareBtnText('SHARING...')
            }

            fetchAPI
                .post(API_ENDPOINTS.BASE_URL, {
                    query: shareInventoryItems,
                    variables: {
                        campaignId,
                        userId: props.user.isAdmin ? props.createdBy : props.user.id,
                        usernamesAndEmailsArray: props.email && props.email !== ''
                            ? [props.email.toString().trim().toLowerCase()]
                            : trimmedData,
                        inventoryItems: modifiedInventory.map((i: any) => {
                            return {
                                inventoryItemId: i.inventoryItemId,
                                quantity: Number(i.quantityForShare),
                                commission: Number(i.commission) * 100,
                                commissionRate: i.commissionRate ? Number(i.commissionRate) : null
                            }
                        }),
                        linkName
                    }
                })
                .then(res => {
                    if (res.data.data.inventoryItem.shareInventory) {
                        props.reloadData()
                        closeModal()
                    } else {
                        alert('An unknown error occurred, try again')
                        setBtnDisabled(false)
                        resetBtn()
                    }
                })
                .catch(err => {
                    console.log(err)
                    setBtnDisabled(false)
                    resetBtn()
                })
        }
    }, [linkName, campaignId, username, modifiedInventory, inventory, props.user, props.createdBy, props.email, selected])

    const handleInventoryChange = useCallback((index, type, value) => {
        if (Number.isNaN(Number(value))) {
            return;
        }

        const temp = JSON.parse(JSON.stringify(modifiedInventory))
        if (type === 'quantity') {
            temp[index].quantityForShare = Number(value);
        } else if (type === 'commission') {
            temp[index].commissionRate = null;
            temp[index].commission = Number(value);
        } else if (type === 'commission rate') {
            temp[index].commissionRate = Number(value);
            temp[index].commission = Number(inventory[index].commission * temp[index].commissionRate / 100);
        }
        setModifiedInventory(temp)
    }, [modifiedInventory, setModifiedInventory])

    const removeFromInventory = useCallback((index) => {
        const temp = JSON.parse(JSON.stringify(modifiedInventory))
        temp.splice(index, 1)
        setModifiedInventory(temp)
        const temp2 = JSON.parse(JSON.stringify(inventory))
        temp2.splice(index, 1)
        setInventory(temp2)
    }, [modifiedInventory, setModifiedInventory, inventory, setInventory])

    if (loading) {
        return <div style={{ width: '100%', justifyContent: 'center', display: 'flex' }}>
            <div className="p-4 w-100 text-center">
                <ClipLoader color={"#000"} loading={true} />
            </div>
        </div>
    }

    return <div style={{ paddingTop: props.email ? '10px' : '20px', paddingBottom: '20px' }}>
        {
            props.email ? null :
                <div style={{ paddingLeft: '40px', paddingRight: '40px', paddingBottom: '40px' }}>
                    <TextArea
                        label='Add Affiliate E-mail/Username *'
                        value={name}
                        onChange={e => setUsername(e.target.value)}
                        required={true}
                        placeholder='Enter one e-mail/Isotope username per line. New users will be invited and e-mailed credentials. Multiple entries permitted.'
                    />
                    {
                        options.length !== 0
                            ? <div>
                                <Label>
                                    Or Pick Current Affiliates
                                </Label>
                                <MultiSelect
                                    options={options}
                                    selected={selected}
                                    onSelectedChanged={(s: any) => setSelected(s)}
                                />
                            </div>
                            : null
                    }
                </div>
        }
        <div style={{ overflowX: "scroll", paddingTop: props.email ? '0px' : '20px' }}>
            {
                props.email && props.email.includes('-additional-link-') && props.forNewLink &&
                <div style={{ paddingLeft: '20px', width: '150px' }}>
                    <Text
                        label='New Link Name'
                        value={linkName}
                        onChange={e => setLinkName(e.target.value)}
                        required={true}
                    />
                </div>
            }
            {
                modifiedInventory.length > 0 ?
                    <table className='table-responsive--base m-0' style={{ width: '100%', textAlign: 'left', fontSize: '12px' }}>
                        <thead>
                            <tr>
                                <td>TICKET</td>
                                <td>QTY</td>
                                {
                                    !username.includes('-additional-link-')
                                        ? <td>COMMISSION</td>
                                        : <td />
                                }
                                <td />
                            </tr>
                        </thead>
                        <tbody>
                            {
                                modifiedInventory.map((item: any, index: number) => {
                                    return <tr key={index} style={{ alignContent: 'center', height: 'auto', padding: '10px', }}>
                                        <td>
                                            {item.name}
                                        </td>
                                        <td >
                                            <NumberInput
                                                value={item.quantityForShare}
                                                min={0}
                                                max={inventory[index].quantity - item.bought}
                                                onChange={(e) => handleInventoryChange(index, 'quantity', e.target.value)}
                                                infoMessage={'0 - ' + (inventory[index].quantity - item.bought).toString()}
                                            />
                                        </td>
                                        {
                                            props.email && props.email.includes('-additional-link-')
                                                ? <td />
                                                : <td>
                                                    <span style={{ display: 'flex', justifyContent: 'start', alignItems: 'center', marginBottom: '4px' }}>
                                                        <button
                                                            onClick={() => {
                                                                const temp = JSON.parse(JSON.stringify(modifiedInventory))
                                                                temp[index].commissionRate = null
                                                                setModifiedInventory(temp)
                                                            }}
                                                            style={{
                                                                paddingTop: '3px',
                                                                width: '24px',
                                                                height: '24px',
                                                                marginLeft: '10px',
                                                                borderRadius: '50%',
                                                                backgroundColor: item.commissionRate === null || item.commissionRate === undefined ? '#242d51' : 'white',
                                                                color: item.commissionRate === null || item.commissionRate === undefined ? 'white' : 'black'
                                                            }}
                                                        >$</button>
                                                        <button
                                                            onClick={() => {
                                                                const temp = JSON.parse(JSON.stringify(modifiedInventory))
                                                                temp[index].commissionRate = Number(item.commission / item.maxCommission * 100)
                                                                setModifiedInventory(temp)
                                                            }}
                                                            style={{
                                                                paddingTop: '3px',
                                                                width: '24px',
                                                                height: '24px',
                                                                marginLeft: '5px',
                                                                borderRadius: '50%',
                                                                backgroundColor: item.commissionRate === null || item.commissionRate === undefined ? 'white' : '#242d51',
                                                                color: item.commissionRate === null || item.commissionRate === undefined ? 'black' : 'white'
                                                            }}
                                                        >%</button>
                                                    </span>
                                                    {
                                                        item.commissionRate === null || item.commissionRate === undefined
                                                            ? <NumberInput
                                                                value={item.commission}
                                                                min={0}
                                                                max={props.user.isAdmin || props.user.id === props.createdBy
                                                                    ? inventory[index].price
                                                                    : inventory[index].commission}
                                                                onChange={e => handleInventoryChange(index, 'commission', e.target.value)}
                                                                required={true}
                                                            />
                                                            : <NumberInput
                                                                value={item.commissionRate}
                                                                min={0}
                                                                max={100}
                                                                onChange={e => handleInventoryChange(index, 'commission rate', e.target.value)}
                                                                required={true}
                                                            />
                                                    }
                                                    <Info>
                                                        Affiliate earns  ${item.commission.toFixed(2)} <br />
                                                        You earn  ${
                                                            props.user.isAdmin || props.user.id === props.createdBy
                                                                ? (inventory[index].price - item.commission).toFixed(2)
                                                                : (inventory[index].commission - item.commission).toFixed(2)
                                                        }
                                                    </Info>
                                                </td>
                                        }
                                        <td>
                                            <button
                                                onClick={() => removeFromInventory(index)}
                                                className='new-button-white-4'
                                            >
                                                REMOVE
                                            </button>
                                        </td>
                                    </tr>
                                })
                            }
                        </tbody>
                    </table>
                    :
                    <p style={{ width: '100%', textAlign: 'center' }}>
                        No tickets available
                    </p>
            }
        </div>
        {
            modifiedInventory.length > 0
                ? <div style={{ width: '100%', textAlign: 'center', marginTop: 18 }}>
                    <button
                        role="submit"
                        type="submit"
                        className="new-button-save"
                        onClick={e => handlePassOn()}
                        disabled={btnDisabled}
                    >
                        {
                            props.email && props.email.split('-')[0] === props.user.username && props.email.includes('@isotope-referral-code.com')
                                ? createBtnText
                                : shareBtnText
                        }
                    </button>
                </div>
                : null
        }
        <div style={{ width: '100%', textAlign: 'center', paddingTop: '10px' }}>
            <button className='new-button-cancel' onClick={() => closeModal()}>
                CANCEL
            </button>
        </div>
    </div>
}

const mapStateToProps = state => ({
    user: UserDucks.getUser(state),
});

export default connect(mapStateToProps)(PassOnInventoryModal);


// WEBPACK FOOTER //
// ./src/pages/campaign/CampaignsDashboard/PassOnInventory.modal.tsx